import {makeActionCreators} from 'mk/common/fluxible/utils';

export const formActions = makeActionCreators({

    formSubmit(context, {fieldValues, action}, done) {
        context.dispatch('FORM_SUBMIT', fieldValues);
        action(context, fieldValues, function(err, response) {
            // err is also response
            if (err) {
                if (err.status === 400) {
                    context.dispatch('FORM_SUBMIT_FAILURE', err.body);
                    // error is handled by the form, no need to send it further
                    done();
                } else {
                    // inform form that we got response
                    context.dispatch('FORM_SUBMIT_FAILURE');
                    done(err);
                }
            } else {
                // TODO: probably all form actions should send response as
                // their second param, but right now only one is sending it
                context.dispatch(
                    'FORM_SUBMIT_SUCCESS',
                    response && response.body
                );
                done();
            }
        });
    },

    formValidationError(context, data, done) {
        context.dispatch('FORM_VALIDATION_ERROR', data);
        done();
    },

    formClear(context, {}, done) { // eslint-disable-line no-empty-pattern
        context.dispatch('FORM_CLEAR');
        done();
    },

});
